export default "__VITE_ASSET__DYb8dw7Q__"